import * as React from 'react'

const styles = require('./styles')

export interface Props {
  errorLabel?: string
}

const Render: React.SFC<Props> = ({ errorLabel }) => (
  <div className={styles.errorContainer}>
    <h3>{errorLabel ? errorLabel : 'Sorry, no offers matched your search. Please try again.'}</h3>
  </div>
)

Render.defaultProps = {
  errorLabel: 'ERROR',
}

export default Render
